import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SzIconComponent } from '../../display/sz-icon/sz-icon.component';
import { SzIconName } from '../../display/sz-icon/sz-icon-name.type';
import { SzIcCircleComponent } from '../../display/sz-ic-circle/sz-ic-circle.component';
import { SzPillComponent } from '../sz-pill/sz-pill.component';
import { SzActionRowKind } from './sz-action-row.types';

@Component({
  selector: 'sz-action-row',
  templateUrl: './sz-action-row.component.html',
  styleUrls: ['./sz-action-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent, SzIcCircleComponent, SzPillComponent]
})
export class SzActionRowComponent {
  readonly kind: InputSignal<SzActionRowKind> = input<SzActionRowKind>('secondary');
  readonly icon: InputSignal<SzIconName> = input.required<SzIconName>();
  readonly title: InputSignal<string> = input.required<string>();
  readonly sub: InputSignal<string | null> = input<string | null>(null);
  readonly soon: InputSignal<boolean> = input<boolean>(false);
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly action: EventEmitter<void> = new EventEmitter<void>();

  onClick(): void {
    if (this.disabled()) return;
    this.action.emit();
  }
}
